import { render, staticRenderFns } from "./communicationDashboardSlideManager.vue?vue&type=template&id=01e81b92&scoped=true"
import script from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSlideManager.vue?vue&type=style&index=0&id=01e81b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e81b92",
  null
  
)

export default component.exports